import { defineComponent as _defineComponent } from 'vue'
import { ref, getCurrentInstance } from 'vue'
import type { Ref } from 'vue'
import { useSubmit } from './FormMixin'
import {
  emailChangeResource,
  authenticateCreate,
  authenticateConfirm,
  authResource,
} from '@/services/auth.service'
import useDeviceInfo from '@/composables/useDevice'
import executeWithRefresh from '@/composables/useRefresher'
import { storage } from '@/utils/session'
import {
  HQ_VPN_ACCESS_TOKEN_STORAGE_NAME,
  HQ_VPN_REFRESH_TOKEN_STORAGE_NAME,
} from '@/const'
import useGlobal from '../../composables/useGlobal'

import MailChecker from 'mailchecker'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailChangeForm',
  setup(__props, { expose }) {
  expose();

const { $t } = useGlobal()
  // import {
  // useAuth,
  // } from '@/stores/auth'

// const store = useAuth()
//  DONT USED VAR!!!!!!!!!!!!!!!!
const authId = ref("")
const isLoad: Ref<boolean> = ref(false)
const activeTimer = ref(false)
const email = ref("")
const code = ref("")
const two_factor_id = ref("")
const emailChanged = ref(false)
const emailError = ref($t('Не подходящий email'))
const timeIsOver = ref(false)

const request = (sendData: any, control: any) => {
  if(MailChecker.isValid(email.value)) {
    isLoad.value = true
    useSubmit(send(sendData), control)
  } else {
    control.setFieldError('token', emailError.value)
  }
  
}

function currentService() {
  const service = activeTimer.value ? authenticateConfirm : authenticateCreate 
  return service
}

function onCountdownEnd() {
  activeTimer.value = false
  timeIsOver.value = true
}

function startTimer() {
  activeTimer.value = true
  timeIsOver.value = false
}

async function getUserSubList() {
  try {
    const res = (await executeWithRefresh( emailChangeResource, null, {}, {
        ...useDeviceInfo(),
        two_factor_id: two_factor_id.value 
      }))
  } catch(e) {
      return Promise.reject(e)
  }
}

const formatter = str => {
  return String(str).length > 1 ? str : `0${str}`
}

const tokenId: Ref<string> = ref('')
const twoFactorId: Ref<string> = ref('')
//  exemple@gmail.com

const send = async (sendData, control) => {
  function prependedData() {
    if (activeTimer.value) {
      return {
        id: tokenId.value,
        code: code.value
      }
    }
    timeIsOver.value = false
    return {
      ...sendData,
      } 
  }
  

  try {
    emailChanged.value = false
    const data = (await currentService().execute({}, prependedData()))
    two_factor_id.value = data.id
    if(activeTimer.value && !timeIsOver.value) {
      const res = (await executeWithRefresh( emailChangeResource, null, {}, {
        ...useDeviceInfo(),
        two_factor_id: two_factor_id.value 
      }))
      emailChanged.value = true
      activeTimer.value = false
      const instance = getCurrentInstance();
      instance.proxy.$forceUpdate();
    }
    else {
      tokenId.value = data.id
      startTimer()
      // store.saveToken(access, refresh)
    } 
  } catch(e) {
      e.json().then(body => {
        Object.keys(body).forEach(key => {
          control.setFieldError(key, body[key][0])
        })
      })
      isLoad.value = false
      return Promise.reject(e)
  }
}

  
const __returned__ = { $t, authId, isLoad, activeTimer, email, code, two_factor_id, emailChanged, emailError, timeIsOver, request, currentService, onCountdownEnd, startTimer, getUserSubList, formatter, tokenId, twoFactorId, send, ref, getCurrentInstance, useSubmit, emailChangeResource, authenticateCreate, authenticateConfirm, authResource, useDeviceInfo, executeWithRefresh, storage, HQ_VPN_ACCESS_TOKEN_STORAGE_NAME, HQ_VPN_REFRESH_TOKEN_STORAGE_NAME, useGlobal, MailChecker }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})